import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ScheduleAMeeting from './scheduleAMeeting';
import {
  getPocList,
  createMeeting,
  getMeetingById,
  updateMeeting,
  getInvoiceList,
  saveDraftMeeting,
  getSaveAsDraftData
} from 'services/redux/brandActivtion/meetings/action';
import { getCorpPocList } from 'services/redux/brandActivtion/corporateClient/action';
import { getCorpClientList, getBaOpportunityFromLeadx } from 'services/redux/brandActivtion/corporateClient/action';
import { documentUploadUrl } from "services/redux/fileUpload/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
  pocList: state.baMeetingReducer.pocList,
  meetingById: state.baMeetingReducer.meetingById,
  corpClientList: state.CorpClientReducer.corpClientList,
  opportunityList: state.CorpClientReducer.opportunityList,
  corpClientPoc: state.CorpClientReducer.corpClientPoc,
  invoiceList: state.baMeetingReducer.invoiceList,
  getDraftEditData: state.baMeetingReducer.getDraftEditData
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPocList,
      createMeeting,
      getMeetingById,
      updateMeeting,
      getCorpClientList,
      documentUploadUrl,
      getCorpPocList,
      getInvoiceList,
      documentUploadUrlPublic,
      getBaOpportunityFromLeadx,
      saveDraftMeeting,
      getSaveAsDraftData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleAMeeting);
